module.exports = __webpack_public_path__ + "media/images/icons/twotone/dollar-95ee7f30a324dc3f57ad011a64d48882.svg";